import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const manageElementsSchema = () =>
  yup.object().shape({
    elements: yup
      .array()
      .of(
        yup.object().shape({
          line: yup.number().label(t('labelElementLine')).nullable(),
          element: yup
            .object()
            .shape({
              id: yup.string().label(t('labelElement')).nullable(),
              name: yup.string().label(t('labelElement')).required(),
            })
            .label(t('labelElement'))
            .nullable()
            .required(),
          quantity: numberSchemaWithTransform().label(t('labelQuantity')).nullable(),
          quantityPerElement: numberSchemaWithTransform()
            .label(t('labelQuantityPerElement'))
            .nullable()
            .required(),
          deleted: yup.boolean().label(t('labelDeleted')).nullable(),
        })
      )
      .label(t('labelElements'))
      .required(),
  });
